import { useState } from "react";
import { MenuItem, Tooltip, IconButton, Menu,} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Offcanvas } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import { useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { Box } from "@mui/system";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import SubtaskBoard from "./SubtaskBoard";
import { useTheme } from "../../../ThemeContext";
import dayjs from "dayjs";
import { CommonAddTaskTab } from "../../common/Task/CommonAddTaskTab";
import CommonDeleteDialog from "../../common/CommonDelete";


const SubTask = ({ subtasklist: SubTasks, fetchSubtasklist: fetchSubtasks }) => {
  const { isDarkMode } = useTheme();
  const [viewMode, setViewMode] = usePersistentFilter("subtaskDetailViewMode", "list");
  const [showProject, setShowProject] = useState(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const handleShowProject = () => {
    setEditData(null);
    setShowProject(!showProject);
  };
  const { reset } = useForm();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
    // ❌ setSelectedRow(null);  (remove pannala, just comment pannirukkom)
  };

  const handleEditSubtask = (event) => {
    event.stopPropagation();
    console.log("Edit subtask triggered for:", selectedRow);
    setEditData(selectedRow);
    setShowProject(true);
    handleMenuClose();
  };
  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <IconButton
            onClick={(e) => handleMenuClick(e, params.row)}
            size="small"
            style={{ padding: "10px", marginBottom:"10px" }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
    { field: "task_id", headerName: "ID", width: 150 },
    { field: "title", headerName: "Task", width: 200 },
    {
      field: "owner",
      headerName: "Owner",
      width: 150,
      renderCell: (params) => {
        const owners = params.row.owners || [];
        if (owners.length === 0) return "N/A";
        const displayValue = `${owners[0].name}${owners.length > 1 ? ` (+${owners.length - 1})` : ""}`;

        const tooltipTitle = (
          <Box>
            {owners.map((o, index) => (
              <div key={index}>{o.name}</div>
            ))}
          </Box>
        );

        return (
          <Tooltip title={tooltipTitle} arrow>
            <Box sx={{ cursor: "pointer" }}>{displayValue}</Box>
            </Tooltip>
        );
      },
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        <span style={{ color: params.row.status_colour }}>
          {params.row.current_status_name}
        </span>
      ),
    },
    { field: "start_date", headerName: "Start Date", width: 150 },
    { field: "end_date", headerName: "Due Date", width: 150 },
    { field: "consumed_hours", headerName: "Duration", width: 150 },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 150,
      renderCell: (params) => (
        <span style={{ color: params.row.priority_colour }}>
          {params.row.priority_name}
        </span>
      ),
    },
    { field: "creator_name", headerName: "Created By", width: 150 },
    {
      field: "added_at",
      headerName: "Created At",
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    { field: "completed_percentage", headerName: "Completed ", width: 150 },
    { field: "estimated_hours", headerName: "work hours ", width: 150 },
  ];

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // const { role: login_user_role } = login_user;

  const navigateSubtask = (params) => {
    const row = params.row;
    navigate(`/projects/projectDetail/${row.project_id}/taskdetail/${row.id}`);
  };

  
  return (
    <>
      <Offcanvas show={showProject} placement="end" style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          <CommonAddTaskTab
            onClear={() => reset()}
            onCancel={() => setShowProject(false)}
            refetchList={fetchSubtasks}
            path_1="task"
            path_2="add/subtask"
            isSubtaskList={true}
            editData={editData}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Box
        className="d-flex justify-content-between align-items-center"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "12px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
          marginTop:"10px"
        }}
      >

        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <Tooltip title="Table View">
            <IconButton
              onClick={() => setViewMode("list")}
              sx={{
                backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <CiViewList size={18} />
              Table
            </IconButton>
          </Tooltip>
          
          <Tooltip title="Board View">
            <IconButton
              onClick={() => setViewMode("board")}
              sx={{
                backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                borderRadius: "4px",
                height: "32px",
                width: "75px",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <MdViewQuilt size={18} />
              Board
            </IconButton>
          </Tooltip>
        </div>
        
        <button className="add_btn" onClick={handleShowProject}>
          Add Subtasks
        </button>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={handleEditSubtask}>
          <CiEdit className="me-2" color="blue" />
          Edit Task
        </MenuItem>
        <CommonDeleteDialog
          name="Subtask"
          refetchList={fetchSubtasks}
          handleListClose={handleMenuClose}
          url="task/delete"
          id={selectedRow?.task_id}
          statusName={selectedRow?.title}
          logHours={selectedRow?.log_hours}
        />
      </Menu>

      <div style={{ width: "100%" }}>
        {loading ? (
          <Loader />
        ) : (
          <Box sx={{ height: SubTasks.length === 0 ? 300 : "auto" }}>
            <div className="h-auto">
              {viewMode === "list" ? (
                <DataGrid
                  rows={SubTasks}
                  columns={columns}
                  pageSizeOptions={[10, 20, 30, 40]}
                  pagination
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  getRowId={(row) => row.task_id}
                />
              ) : (
                <SubtaskBoard
                  numericId={id}
                  allTasks={SubTasks.map(t => ({
                    ...t,
                    id: t.id || t.task_id
                  }))}
                  onRefresh={fetchSubtasks}
                  loading={loading}
                  onOpenTask={(task) => {
                    setEditData(task);
                    setShowProject(true);
                  }}
                />
              )}
            </div>
          </Box>
        )}
      </div>
    </>
  );
};

export default SubTask;